import { gql } from '@apollo/client';
const customerFragment = gql`
  fragment CustomerFragment on Customer {
    id
    email
    metadata
  }
`;

const paymentMethodFragment = gql`
  fragment PaymentMethodFragment on PaymentMethod {
    id
    type
  }
`;

export const FETCH_CUSTOMER_BY_TENANT_ID = gql`
  ${customerFragment}
  query GetCustomerByTenantId($tenantId: String!) {
    getCustomerByTenantId(tenantId: $tenantId) {
      ...CustomerFragment
    }
  }
`;

export const FETCH_PAYMENT_METHODS_BY_CUSTOMER_ID = gql`
  ${paymentMethodFragment}
  query GetPaymentMethodByCustomerId($customerId: String!) {
    getPaymentMethodByCustomerId(customerId: $customerId) {
      ...PaymentMethodFragment
      card {
        brand
        last4
        expMonth
        expYear
      }
    }
  }
`;

export const CREATE_SETUP_INTENT = gql`
  mutation CreateSetupIntent($customerId: String!) {
    createSetupIntent(customerId: $customerId) {
      clientSecret
    }
  }
`;

export const DELETE_PAYMENT_METHOD = gql`
  ${paymentMethodFragment}
  mutation DeletePaymentMethod($paymentMethodId: String!, $tenantId: String!) {
    deletePaymentMethod(
      paymentMethodId: $paymentMethodId
      tenantId: $tenantId
    ) {
      success
      paymentMethod {
        ...PaymentMethodFragment
      }
    }
  }
`;
